import { createContext } from "react";
import { Drawer } from "./drawer.provider";

export type DrawerContextType = {
  drawers: Drawer[];
  setDrawers: React.Dispatch<React.SetStateAction<Drawer[]>>;
  open: (name: string) => void;
  close: (name: string) => void;
  isOpen: (name: string) => boolean;
};

export const DrawerContext = createContext<DrawerContextType>({
  drawers: [],
  setDrawers: () => {},
  open: (_name: string) => {},
  close: (_name: string) => {},
  isOpen: (_name: string) => false,
});
